/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'box': {
    width: 16,
    height: 16,
    viewBox: '0 0 28 32',
    data: '<path pid="0" d="M13.46.13c.3-.15.64-.17.95-.05l.13.05 12.84 6.84c.34.18.57.51.61.89L28 8v14.92c0 .36-.17.7-.44.92l-.11.07-12.85 7.92c-.32.2-.72.22-1.06.07l-.13-.06L.57 24.23c-.31-.19-.52-.5-.56-.87L0 23.23V8c0-.38.19-.74.5-.95l.12-.08L13.46.13zM2.31 9.34v13.22l10.53 6.24V15.5L9.3 13.44v2.58c0 .64-.52 1.16-1.16 1.16L7 16.7l-.39-.2c-.45-.24-.77-.46-.77-.96V11.4L2.31 9.34zm23.38 0l-10.54 6.17v13.25l10.54-6.5V9.35zm-5.44-3.53l-10.13 5.42L14 13.49l9.86-5.76-3.6-1.92zM14 2.48L4.14 7.72 6.6 9.16l9.95-5.32L14 2.48z"/>'
  }
})
